import React from 'react';

export const pageMeta = {
  "name": "JS 2015 (ES6)",
  "link": "/javascript/versions/es6"
};

export default function JavascriptVersionsEs6() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS 2015 (ES6)</h2>
      <p>Route: /javascript/versions/es6</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
